async function getShopifyAppApi() {
  const shopify = window.shopify;
  if (!shopify) {
    return null;
  }

  if (shopify.app && typeof shopify.app.extensions === 'function') {
    return shopify.app;
  }

  if (typeof shopify.app === 'function') {
    const appApi = shopify.app();
    if (appApi && typeof appApi.extensions === 'function') {
      return appApi;
    }
  }

  return null;
}

export async function fetchThemeAppExtensionStatuses() {
  const appApi = await getShopifyAppApi();
  if (!appApi) {
    return { available: false, blocks: [] };
  }

  const extensions = await appApi.extensions();
  const themeExtensions = (extensions || []).filter(
    extension => extension.type === 'theme_app_extension'
  );
  const blocks = themeExtensions
    .flatMap(extension => extension.activations || [])
    .map(activation => {
      const placements = Array.isArray(activation.activations) ? activation.activations : [];
      const status = activation.status || 'available';
      return {
        handle: activation.handle,
        name: activation.name || activation.handle,
        target: activation.target,
        status,
        placements,
        presentInTheme: status === 'active' || placements.length > 0,
        isEmbed: activation.target && activation.target !== 'section',
      };
    })
    .sort((a, b) => {
      if (a.isEmbed !== b.isEmbed) {
        return a.isEmbed ? -1 : 1;
      }
      return a.name.localeCompare(b.name);
    });

  return { available: true, blocks };
}
